// extracted by mini-css-extract-plugin
export default {"error":"SignErrors_error__r9XhU"};